import React, { useMemo, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import useResponsiveness from '@/hooks/useResponsiveness';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import Button from '@/components/Buttons/Button';
import { useModalStore } from '@/store';

const createStyles = (colors, isXS) => StyleSheet.create({
  noCreditsContainer: {
    alignItems: 'center',
    paddingVertical: isXS ? 20 : 50,
    paddingHorizontal: isXS ? 20 : 30,
    width: '100%',
    flex: 1,
    backgroundColor: colors.solid_color_tertiary,
    borderRadius: isXS ? 12 : 24,
    borderWidth: 1,
    borderColor: colors.border_color_secondary,
  },
  noCreditsContainerInner: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    width: '100%',
    flexDirection: isXS ? 'row' : 'column',
  },
  noCreditsIconContainer: {
    height: isXS ? 54 : 94,
    width: isXS ? 54 : 94,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.accent_color_primary + '15',
    borderRadius: isXS ? 12 :24,
    marginBottom: isXS ? 0 : 24,
    transform: [{ rotate: '-10deg' }],
  },
  sparkleIcon: {
    position: 'absolute',
    top: -5,
    right: -5,
  },
  titleContainer: {
    alignItems: isXS ? 'flex-start' : 'center',
    paddingLeft: isXS ? 20 : 0,
    flex: 1,
  },
  title: {
    textAlign: isXS ? 'left' : 'center',
    marginBottom: isXS ? 4 : 8,
  },
  subtitle: {
    textAlign: isXS ? 'left' : 'center',
    lineHeight: isXS ? 18 : 24,
    maxWidth: isXS ? '100%' : 280,
  },
  buttonContainer: {
    width: '100%',
    maxWidth: 280,
    marginTop: 20,
  }
});

function NoCreditsSection({ noButton = false }) {
  const { colors } = useTheme();
  const { isXS } = useResponsiveness();
  const styles = useMemo(() => createStyles(colors, isXS), [colors, isXS]);
  const { openModal } = useModalStore(state => state.actions);
  const handleOnOpenCreditsPurchaseModal = useCallback(() => {
    openModal('CreditsPurchaseModal', { initialTab: 'buy-credits' });
  }, [openModal]);

  return (
    <View style={styles.noCreditsContainer}>
      <View style={styles.noCreditsContainerInner}>
        <View style={styles.noCreditsIconContainer}>
          <Icon name="coins" size={isXS ? 22 : 40} color={colors.text_color_primary} />
          <View style={styles.sparkleIcon}>
            <Icon name="sparkles" size={isXS ? 16 : 24} color={colors.text_color_primary} />
          </View>
        </View>
        <View style={styles.titleContainer}>
          <Text style={styles.title} color="primary" size={isXS ? 'l' : 'xxl'} weight='bold'>Time to Power Up!</Text>
          <Text style={styles.subtitle} color="secondary">
            Your creative journey awaits! Add more credits to keep the conversation flowing.
          </Text>
          {!noButton && (
            <View style={styles.buttonContainer}>
              <Button
                variant="primary"
                text="Keep Creating"
                onPress={handleOnOpenCreditsPurchaseModal}
                isFullWidth
              />
            </View>
          )}
        </View>
      </View>
    </View>
  );
} 

export default React.memo(NoCreditsSection);